import 'SF/dashboard/templates/TemplateFactory.js';
import 'SF/dashboard/templates/AgendaTemplateCommonMemberFunctions.js';
import 'SF/dashboard/templates/AppointmentTemplate.js';
import 'SF/dashboard/templates/CourseTemplate.js';
import 'SF/dashboard/templates/EventTemplate.js';
import 'SF/dashboard/templates/FlagTemplate.js';
import 'SF/dashboard/templates/GeneralDateTemplate.js';
import 'SF/dashboard/templates/GroupSessionTemplate.js';
import 'SF/dashboard/templates/KudosTemplate.js';
import 'SF/dashboard/templates/ReferralTemplate.js';
import 'SF/dashboard/templates/TodoTemplate.js';
